import React, { useEffect } from 'react';
import About from '../components/About';

const AboutPage = () => {
  useEffect(() => {
  document.title = "Who we are | Ciqura Labs";

    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh', paddingTop: '80px' }}>
      <About />
    </div>
  );
};

export default AboutPage;